import { useRouter } from 'next/router'
import Link from 'next/link'
import Icon from 'components/icon/icon'
import Tooltip from 'components/tooltip/tooltip'
import { cn, getRoute } from 'utils/helpers'
import styles from './menu.module.scss'

export default function Menu({ items, activeUntil }) {
    const { pathname } = useRouter()
    const rootPages = [getRoute('[profile]'), getRoute('[account]')]

    return (
        <div className={styles.menu}>
            {items.map((item, k) => {
                const { url, text, count, tooltip } = item
                const active = (pathname.startsWith(url) && !rootPages.includes(url)) || url == pathname

                const number = !!count && (
                    <Tooltip content={tooltip}>
                        <span>{count}</span>
                    </Tooltip>
                )

                return item.onClick && !activeUntil ? (
                    <div key={k} onClick={item.onClick} className={cn(active == k && styles.active)}>
                        <Icon className={styles.icon}>{item.no}</Icon>
                        {text}
                    </div>
                ) : item.url ? (
                    <Link key={k} href={item.url}>
                        <a className={cn(active && styles.active)}>
                            <Icon icon={item.icon} className={styles.icon} />
                            {text}
                            {number}
                            {item.tag && <div className={styles.tag}>{item.tag}</div>}
                        </a>
                    </Link>
                ) : (
                    <div
                        key={k}
                        onClick={item.onClick}
                        className={cn(
                            item.onClick || styles.inactive,
                            active == k || k <= activeUntil ? styles.active : null
                        )}
                    >
                        <Icon className={styles.icon}>{item.no}</Icon>
                        {text}
                    </div>
                )
            })}
        </div>
    )
}
